import {
  useTranscriptExpansion,
  useTranscriptSettings,
} from "./TranscriptContext";
import { Fragment } from "react/jsx-runtime";
import type { StreamMessage } from "../../hooks/useStreamingText";
import type { GroupedEntry } from "./groupChatEntries";
import { ToolUseGroup } from "./ToolUseGroup";
import { Message } from "./transcriptStyles";

type Props = {
  grouped: Extract<GroupedEntry, { type: "toolGroup" }>;
  prevGrouped: GroupedEntry | undefined;
  nextGrouped: GroupedEntry | undefined;
  dateMarker: React.ReactNode;
  streamingEntries: ReadonlyMap<string, StreamMessage>;
};

export function ToolGroupRow({
  grouped,
  prevGrouped,
  nextGrouped,
  dateMarker,
  streamingEntries,
}: Props) {
  const {
    expandedToolGroups,
    setExpandedToolGroups,
    expandedToolUse,
    setExpandedToolUse,
  } = useTranscriptExpansion();
  const { toolsByName, onProvideToolResult } = useTranscriptSettings();
  const nextIsAssistantMessage =
    nextGrouped?.type === "single" &&
    nextGrouped.entry.entryType === "AssistantMessage";
  const prevIsUserMessage =
    prevGrouped?.type === "single" &&
    prevGrouped.entry.entryType === "UserMessage";

  return (
    <Fragment>
      {dateMarker}
      <Message
        style={{
          marginBottom: nextIsAssistantMessage ? 12 : nextGrouped ? 32 : 0,
          ...(prevIsUserMessage && !grouped.isTrailing && { marginTop: 12 }),
        }}
      >
        <ToolUseGroup
          entries={grouped.entries}
          activePromptId={grouped.activePromptId}
          collapsed={!expandedToolGroups.has(grouped.groupId)}
          toggleCollapsed={() =>
            setExpandedToolGroups((prev) => {
              const next = new Set(prev);
              if (next.has(grouped.groupId)) {
                next.delete(grouped.groupId);
              } else {
                next.add(grouped.groupId);
              }
              return next;
            })
          }
          expandedToolUse={expandedToolUse}
          setExpandedToolUse={setExpandedToolUse}
          tools={toolsByName}
          isTrailing={grouped.isTrailing}
          responseStarted={grouped.responseStarted}
          onProvideResult={onProvideToolResult}
          streamingEntries={streamingEntries}
        />
      </Message>
    </Fragment>
  );
}
